export default "__VITE_ASSET__cdwHuG_G__"